import classNames from 'classnames';
import React, { useCallback, useMemo } from 'react';
import { TextField as TPATextField, Text } from 'wix-ui-tpa/cssVars';
import { FIELD_TYPES } from '../../constants';
import { FIELD_ERROR_CLASS, useError } from '../../field-error';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description';
import { FieldErrorWUT } from '../field-error';
import { FieldLabelWUT } from '../field-label';
import { classes } from './payment-input-field-wut.st.css';
import { useConfig } from '../../contexts/config-context';
import { toProductValue } from './payment-input-field-utils';
import { useTpaStyleParams } from '../shared/use-tpa-style-params';
import { getNumberInputError, localizeNumberInput } from '../shared/numeric-input-utils';
import { useInvokeCallback } from '../shared/use-invoke-callback';
export const PaymentInputFieldWUT = _ref => {
  var _value$;
  let {
    id,
    target,
    label,
    fixedPrice,
    hideLabel = false,
    placeholder,
    required = false,
    value = null,
    onChange,
    onFocus,
    onBlur,
    error,
    customErrors,
    disabled = false,
    description,
    validation,
    fieldType = FIELD_TYPES.PAYMENT_INPUT,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const _error = getNumberInputError(validation, error);
  const {
    hasError,
    errorMessage
  } = useError(_error, customErrors, fieldType);
  const {
    currency,
    locale
  } = useConfig();
  const {
    inputTheme,
    isBorderStyleNone
  } = useTpaStyleParams();
  const invokeBlur = useInvokeCallback(onBlur);
  const paymentValue = (value == null || (_value$ = value[0]) == null ? void 0 : _value$.price) ?? '';
  const payment = useMemo(() => {
    var _validation$predefine;
    return validation == null || (_validation$predefine = validation.predefined) == null || (_validation$predefine = _validation$predefine.paymentOptions) == null || (_validation$predefine = _validation$predefine.products) == null ? void 0 : _validation$predefine[0];
  }, [validation]);
  const handleOnBlur = useCallback(event => {
    const filteredInput = event.target.value.replace(',', '.').match(/[\d.]+/);
    if (filteredInput) {
      const decimal = Math.floor(parseFloat(filteredInput[0]) * 100) / 100;
      const localisedNumber = localizeNumberInput(String(decimal), locale);
      onChange([toProductValue(payment, Number(localisedNumber))]);
    } else {
      onChange([toProductValue(payment, '')]);
    }
    invokeBlur();
  }, [onChange, payment, locale, invokeBlur]);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => fixedPrice ? /*#__PURE__*/React.createElement(Text, {
      className: classes.text,
      "aria-labelledby": labelId,
      id: inputId
    }, `${(currency == null ? void 0 : currency.sign) || (currency == null ? void 0 : currency.code)}${paymentValue}`) : /*#__PURE__*/React.createElement(TPATextField, {
      id: inputId,
      placeholder: placeholder,
      "aria-labelledby": labelId,
      "aria-describedby": ariaDescribedBy,
      className: classNames(classes.paymentInput, {
        [FIELD_ERROR_CLASS]: hasError,
        [classes.noBorder]: isBorderStyleNone
      }),
      value: String(paymentValue),
      name: target,
      onChange: event => onChange([toProductValue(payment, event.target.value)]),
      disabled: disabled,
      onBlur: handleOnBlur,
      onFocus: onFocus,
      theme: inputTheme,
      error: hasError,
      newErrorMessage: true,
      prefix: (currency == null ? void 0 : currency.sign) || (currency == null ? void 0 : currency.code),
      autoComplete: "off",
      required: required
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=payment-input-field-wut.js.map